import { render, staticRenderFns } from "./userPaymentTieredPenetrationRate.vue?vue&type=template&id=70b387cc&scoped=true&"
import script from "./userPaymentTieredPenetrationRate.vue?vue&type=script&lang=js&"
export * from "./userPaymentTieredPenetrationRate.vue?vue&type=script&lang=js&"
import style0 from "./userPaymentTieredPenetrationRate.vue?vue&type=style&index=0&id=70b387cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b387cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b387cc')) {
      api.createRecord('70b387cc', component.options)
    } else {
      api.reload('70b387cc', component.options)
    }
    module.hot.accept("./userPaymentTieredPenetrationRate.vue?vue&type=template&id=70b387cc&scoped=true&", function () {
      api.rerender('70b387cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/userPaymentTieredPenetrationRate.vue"
export default component.exports